export class UnitTwelevePdfReq {
    id: number
    soNumber: string;
    dropDown: string;

}